<script setup lang="ts">
  import { toRefs } from 'vue';
  import type { PortalView } from 'dfx/edge/edge.did';
  import { getAbbreviatedMemberCount } from '../lib/get-abbreviated-member-count';
  import { getAbbreviatedContentCount } from '../lib/get-abbeviated-content-count';

  const props = defineProps<{
    portalView: PortalView;
    hideLabels?: boolean;
  }>();

  const { portalView } = toRefs(props);
</script>
<template>
  <div class="flex items-center gap-4 text-sm">
    <div class="flex items-center gap-1">
      <base-icon name="outlined-users2" size="w-4 h-4" class="text-white" />
      <span class="text-white">
        {{ getAbbreviatedMemberCount(portalView) }}
      </span>
      <span v-if="!hideLabels" class="lowercase">{{ $t('members') }}</span>
    </div>
    <div class="flex items-center gap-1">
      <base-icon
        name="vuesax-linear-simcard2"
        size="w-4 h-4"
        class="text-white"
      />
      <span class="text-white">
        {{ getAbbreviatedContentCount(portalView) }}
      </span>
      <span v-if="!hideLabels" class="lowercase">{{ $t('posts') }}</span>
    </div>
  </div>
</template>
